import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { FlowData, HomeState } from "@/components/PageHome/redux/types";

const selectHome = (state: RootState): HomeState => state?.home;

export default createDraftSafeSelector(selectHome, (home: HomeState): FlowData => home.flowData);
